export default "__VITE_ASSET__CygflrpU__"